// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

// App Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeContractDetailList} from "./contractDetailListSlice";
import {getContractMarketList} from "../../DataPointAttribute/DataPointAttributeClient";
import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";


// Main Function
export default function ContractMarketListDrawer() {


    // ****************** BEGIN STATES ****************************

    const [contractMarketList, setContractMarketList] = useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const selectorContractId = useSelector((state) => state.contractDetailListSlc.value.contractId);
    const selectorContractName = useSelector((state) => state.contractDetailListSlc.value.contractName);
    const selectorMarketListDrawerState = useSelector((state) => state.contractDetailListSlc.value.marketListDrawerState);

    // ********************** END STORE ********************************
    

    // ****************** BEGIN DISPATCH ****************************
    
    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchContractMarketList = () =>
        getContractMarketList(selectorContractId)
            .then(data => {
                console.log("this as my response");
                console.log(data);
                setContractMarketList(data);
            });

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        fetchContractMarketList();
    }, [ useSelector((state) => state.contractDetailListSlc.value.marketListDrawerState)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    function closeContractMarketListDrawer() {
        dispatchData(changeContractDetailList({id: 0, marketListDrawerState: false}));
    };

    // ***************** END CONTROLS ***************************


    // ***************** BEGIN MISC ***************************

    const renderContractMarketList = contractMarketList => {
        if (contractMarketList.length <= 0) {
            return "No Data";
        }}

    // *************** END MISC *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = contractMarketList => [

        {    field: 'contractId',
            headerName: 'Contract ID',
            description: '',
            sortable: true,
            width: 60,
            hide: true,
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'mcode',
            headerName: 'Code',
            description: '',
            sortable: true,
            editable: true,
            hide: true,
            // editable: true,
            width: 200,
        },
        {
            field: 'name',
            headerName: 'Name',
            description: '',
            sortable: false,
            editable: true,
            width: 500,
        },
        {
            field: 'category',
            headerName: 'Category',
            description: '',
            sortable: true,
            editable: true,
            hide: true,
            // editable: true,
            width: 150,
        },
        {
            field: 'description',
            headerName: 'Description',
            description: '',
            sortable: false,
            editable: true,
            width: 1000,
        },

    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 1000 },
                }}
                anchor='right'
                open={selectorMarketListDrawerState}
                initialState={{open: false}}
                onClose={closeContractMarketListDrawer}
            >
                <Box style={{cursor:'pointer'}} sx= {{pl: 2}}>
                    <h1 onClick={() => closeContractMarketListDrawer()}>Market List</h1>
                    <Stack direction="row" spacing={1}>
                        {/*<Typography component="span">id:</Typography>*/}
                        {/*<Typography component="span" fontWeight="bold">{selectorContractId}</Typography>*/}
                        {/*<Box sx={{ ml: 6 }} /> /!* Adds extra spacing before 'name:' *!/*/}
                        {/*<Typography component="span">name:</Typography>*/}
                        <Typography component="span" fontWeight="bold">{selectorContractName}</Typography>
                    </Stack>
                </Box>
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"ContractMarketList"}
                    rows={contractMarketList}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(contractMarketList)}
                    density={"compact"}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    rowKey={contractMarketList => contractMarketList.id}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
